const Suffixes = ["None", "JR", "SR", "III", "IV", "V"];

export default Suffixes;
